import React, { Fragment, Suspense } from "react";
import { Helmet } from "react-helmet";
import { metaTag } from "../Library/commomLib";
import Preloader from "../Components/Common/Preloader";
const TypographyComponent = React.lazy(() => import("../Components/RootComponents/TypographyComponent"));
const TypographyPage = () => {
  return (
    <Fragment>
      <Suspense fallback={<Preloader />}>
        <Helmet>
          <title>{metaTag}</title>
          <meta name={metaTag} content={metaTag} />
        </Helmet>
        <TypographyComponent />
      </Suspense>
    </Fragment>
  );
};

export default TypographyPage;
